export function getCloudinaryUrl(url) {
  return url ?? "";
}

export function getCloudinarySrcSet() {
  return "";
}
